module.exports = {"sql_api_url":"https://{{user}}.cartodb.com/api/v2/sql","import_api_url":"https://{{user}}.cartodb.com/api/v1/imports","maps_api_url":"https://{{user}}.cartodb.com/api/v1/map/named"}


//////////////////
// WEBPACK FOOTER
// ./node_modules/cartodb/lib/resources.json
// module id = 233
// module chunks = 0